import React, { PropsWithChildren } from "react";

import "./CaptiveLayout.scss";

interface CaptiveLayoutProps extends PropsWithChildren {}

export const CaptiveLayout = ({ children }: CaptiveLayoutProps) => {
  return (
    <div className="captive-layout">
      <div className="shade" />
      <div className="border">
        <div className="content">{children}</div>
      </div>
    </div>
  );
};
